import type { MarketVariants } from '@/lib/i18n'

export type Slide6DocumentCopy = {
  eyebrow: string
  title: string
  body: string
  /** Checklist rows, rendered in order with a check icon. */
  items: string[]
}

export const copy: MarketVariants<Slide6DocumentCopy> = {
  US: {
    eyebrow: 'Step four',
    title: 'Document everything.',
    body: 'Banks, police, and investigators all ask for the same details. Saving them now makes every call easier later.',
    items: [
      'Screenshots of messages, emails, or websites',
      'Phone numbers, email addresses, and usernames they used',
      'Dates and times of every contact',
      'Amounts sent, and how they were sent',
      'Any case or reference numbers from your bank',
    ],
  },
  ar: {
    eyebrow: 'الخطوة الرابعة',
    title: 'وثّق كل شيء.',
    body: 'يطلب البنك والشرطة والمحققون جميعاً التفاصيل نفسها. حفظها الآن يجعل كل اتصال لاحق أسهل.',
    items: [
      'لقطات شاشة للرسائل أو رسائل البريد الإلكتروني أو المواقع الإلكترونية',
      'أرقام الهواتف وعناوين البريد الإلكتروني وأسماء المستخدمين التي استخدموها',
      'تواريخ وأوقات كل تواصل',
      'المبالغ المرسلة، وطريقة إرسالها',
      'أي أرقام قضايا أو أرقام مرجعية من بنكك',
    ],
  },
}
